import ThisModule from "./SessionTypesTable";

export default ThisModule;
